// Import required libraries
import React from "react";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";

// Import data/utils
import logo from "../../../assets/images/rb-logo.png";
import { updateSourceInputs, updateAdminInputs } from "../../redux/actions";

function RbLogo(props) {
  const { updateSourceInputs, updateAdminInputs } = props;
  let history = useHistory();

  const clearReduxState = () => {
    // ADMIN STATE
    updateAdminInputs("documents_list", []);
    updateAdminInputs("current_document", "");
    updateAdminInputs("usecase_metadata", {});
    updateAdminInputs("admin_metadata", {});

    // NORMAL USECASE STATE
    updateSourceInputs("current_iqvia_source_file_id", []);
    updateSourceInputs("current_nielsen_source_file_id_list", []);
    updateSourceInputs("current_iqvia_source_file_id", "");
    updateSourceInputs("current_nielsen_source_file_id", "");
    updateSourceInputs("isNewMappingType_logs", []);
    updateSourceInputs("isNewPowerBrand_logs", []);
    updateSourceInputs("isNewLocalValue_logs", []);
    updateSourceInputs("isNewMappedValue_logs", []);
    updateSourceInputs("isNewRBFilteredBrand_logs", []);
    updateSourceInputs("isNewRBFilteredBrandDropdownValue", false);
    updateSourceInputs("isNewPowerBrandDropdownValue", false);
    updateSourceInputs("isNewDropdownValue", false);
    updateSourceInputs("isNewDropdownLocalValue", false);
    updateSourceInputs("isNewDropdownMappedValue", false);
    updateSourceInputs("has_awaiting_data", false);
    updateSourceInputs("current_usecase", "");
    updateSourceInputs("current_usecase_list", []);
    updateSourceInputs("data", []);
    updateSourceInputs("checked_rows_count", 0);
    updateSourceInputs("current_bussines_unit", "");
    updateSourceInputs("current_dimension", {});
    updateSourceInputs("dimensions_list", []);
    updateSourceInputs("current_source", "");
    updateSourceInputs("current_source_label", "");
    updateSourceInputs("current_target_gold_layer", "");
    updateSourceInputs("current_country", "");
    updateSourceInputs("current_country_code", "");
    updateSourceInputs("current_cmu", "");
    updateSourceInputs("current_category", "");
    updateSourceInputs("current_ssfFileId", "");
    updateSourceInputs("current_filter_value", "");
    updateSourceInputs("current_template_filter_value", "");
    updateSourceInputs("current_template_ssfFileId", "");
    updateSourceInputs("current_table_name", "");
    updateSourceInputs("is_initial", true);
    updateSourceInputs("is_table_loading", true);
    updateSourceInputs("searchValue", "");
    updateSourceInputs("any_row_isEditing", false);
    updateSourceInputs("isFileUploaded", false);
    updateSourceInputs("isNewDataInserted", false);
    updateSourceInputs("current_bussines_unit_list", []);
    updateSourceInputs("current_mapped_source", []);
    updateSourceInputs("current_target_gold_layer_list", []);
    updateSourceInputs("current_mapped_country", []);
    updateSourceInputs("master_table_countries", []);
    updateSourceInputs("current_ssf_file_id", []);
    updateSourceInputs("current_template_ssf_file_id", []);
    updateSourceInputs("current_category_data", []);
    updateSourceInputs("current_mapped_data", []);
    updateSourceInputs("current_mapped_data_main", []);
    updateSourceInputs("modified_mapped_data", []);
    updateSourceInputs("current_filters", []);
    updateSourceInputs("appliedFilters", []);
    updateSourceInputs("download_sample_file", []);
    updateSourceInputs("filtered_Rows", []);
    updateSourceInputs("current_columns", []);
    updateSourceInputs("actualData", []);
    updateSourceInputs("recommendedModel", []);
    updateSourceInputs("approvalData", []);
    updateSourceInputs("approvalTable_Header", []);
  };

  const handleNavClick = (e, path) => {
    e.preventDefault(); // ⛔ stop default <NavLink> navigation
    clearReduxState();
    history.push(`${path}`);
  };

  const headerText = "Harbor";
  const headerRedirectUrl = "/harbor/home";

  return (
    <div className="top-left-nav">
      <Link
        to={headerRedirectUrl}
        onClick={(e) => handleNavClick(e, headerRedirectUrl)}
        className="rb-logo-container"
      >
        <img className="rb-logo" src={logo} alt="RB Logo" />
      </Link>
      <Link
        to={headerRedirectUrl}
        onClick={(e) => handleNavClick(e, headerRedirectUrl)}
        className="rb-logo-text"
      >
        {headerText}
      </Link>
    </div>
  );
}

const mapStateToProps = (state) => ({
  user: state.user,
});

const mapDispatchToProps = {
  updateSourceInputs,
  updateAdminInputs,
};

export default connect(mapStateToProps, mapDispatchToProps)(RbLogo);
